import React from 'react';
import { mount, shallow } from 'enzyme';
import toJSON from 'enzyme-to-json';
import wait from 'waait';
import { render as rtlRender, screen, cleanup, act } from '@testing-library/react';
import '@testing-library/jest-dom';

import MyIcscCarousel from '.';
import Provider from '../../../testing/Provider';
import CAROUSEL_DATA from '../../../testing/data/carousel';

const loader = (
    <div data-test="my-icsc-carousel-loader">
        <div />
        <span>Loading</span>
    </div>
);

afterEach(() => {
    cleanup();
});

const mountComponent = async ({ slides = [], isLoading = true }) => {
    const wrapper = mount(
        <Provider>
            <MyIcscCarousel section="dashboard" slides={slides} isLoading={isLoading} fetchCarousel={jest.fn} />
        </Provider>
    );
    await wait();
    wrapper.update();
    return wrapper;
};

// WIP
describe('<MyIcscCarousel />', () => {
    // it('renders properly and matches snapshot', async () => {
    //     // const tree = shallow(<MyIcscCarousel />);
    //     // expect(toJSON(tree)).toMatchSnapshot();
    //     const wrapper = await mountComponent({});
    //     wrapper.debug();
    //     // const container = wrapper.find('div[data-test="badge-allotment-detail"]');
    //     expect(wrapper).toMatchSnapshot();
    // });
    // test('renders loader', async () => {
    //     // rtlRender(<MyIcscCarousel isLoading fetchCarousel={() => {}} />, { wrapper: Provider });
    //     // expect(screen.getByText(/Loading/)).toBeInTheDocument();
    //     const wrapper = await mountComponent({});
    //     expect(wrapper.containsMatchingElement(loader)).toBeTruthy();
    // });
    // test('hides loader', async () => {
    //     // rtlRender(<MyIcscCarousel isLoading={false} slides={CAROUSEL_DATA} fetchCarousel={() => {}} />, {
    //     //     wrapper: Provider,
    //     // });
    //     // screen.debug();
    //     // expect(screen.getByText(/Loading/)).toBeNull();
    //     const wrapper = await mountComponent({ isLoading: false, slides: CAROUSEL_DATA });
    //     expect(wrapper.containsMatchingElement(loader)).toBeFalsy();
    // });
    // it('hides loader', async () => {
    //     // render(<MyIcscCarousel isLoading={false} slides={CAROUSEL_DATA.data} />);
    //     // screen.debug();
    //     // expect(screen.queryByText(/Loading/)).toBeNull();
    //     const wrapper = await mountComponent({});
    //     await wait();
    //     wrapper.update();
    //     // debugger;
    //     expect(wrapper.containsMatchingElement(loader)).toBeFalsy();
    // });
});
